<div class="flex flex-col min-h-screen">
  <div class="bg-body flex flex-col flex-1">
    <app-navbar />
    <div class="flex-1">
      <router-outlet />
    </div>
  </div>
  @if (showFooter()) {
    <app-footer />
  }
</div>
<p-toast />